import React, { Component } from "react";
import { Route } from 'react-router-dom';
// import { connect } from 'react-redux';

// import { Button, Form } from 'react-bootstrap';
// import alertify from 'alertifyjs';
// import { saveBlog, fetchBlogs, fetchCategories, updateBlog } from '../actions/api'

import BlogForm from "./blogForm";

import ViewBlogs from "./viewBlogs";class Blogs extends Component {
  constructor(props) {
    super(props);
    this.state = { blogs: null, categories: null, renderInput: false, };
  }


  render() {
    return (
      <>
        <Route path={this.props.match.url + "/add"} component={BlogForm} />
        <Route path={this.props.match.url + "/view"} component={ViewBlogs} />
        <Route path={this.props.match.url + "/edit"} component={BlogForm} />
      </>
    )
  }
}
// export default connect(mapStateToProps, mapDispatchToProps)(Blogs);
export default Blogs;